import { useParams } from 'react-router-dom';
import { useRealListingInjector } from '@/hooks/useRealListingInjector';
import { RealListingContext } from '@/contexts/RealListingContext';
import ListingDetail from './ListingDetail';

export default function RealListingDetail() {
  const { slug } = useParams<{ slug: string }>();
  const { loading, listing } = useRealListingInjector(slug);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="flex flex-col items-center gap-3">
          <div className="h-10 w-10 animate-spin rounded-full border-2 border-primary border-t-transparent" />
          <p className="text-sm text-muted-foreground">Loading listing…</p>
        </div>
      </div>
    );
  }

  return (
    <RealListingContext.Provider value={listing}>
      <ListingDetail />
    </RealListingContext.Provider>
  );
}